
import { Camera, CameraResultType } from '@capacitor/camera';
import {
  IonContent,
  IonPage,
  IonLoading,
  useIonToast,
  useIonViewWillEnter,
  IonButton,
  IonIcon,
  useIonRouter,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonSearchbar,
  IonList,
  IonItem,
  IonLabel,
  IonCheckbox,
  IonSkeletonText,
} from '@ionic/react';
import { MenuItem, Select } from '@material-ui/core';
import { informationCircle, } from 'ionicons/icons';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import axios from '../../axios';
import Header from '../../components/Header';
import { createMaintenanceFields, createCheckList } from '../../models/createMaintenanceFields';
import { getAssetComponentName, getSetAssetComponentType, getSetAssetNameWithNoMaintenance, getSetProjectList } from '../../utils';


const CreateMainten1: React.FC = () => {
  const router = useIonRouter();
  const [present] = useIonToast();

  const { t } = useTranslation();

  // const [isScan, setIsScan] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);


  // const [isOnline, setIsOnline] = useState(Boolean);
  const [showLoading, setShowLoading] = useState(false);

  const [data, setData] = useState<any>(createMaintenanceFields);
  // const [checklist, setChecklist] = useState({
  //   activity: '',
  //   yes_or_no: '',
  //   remarks: '',
  // });


  const [projects, setProjects] = useState<any>([]);
  const [selectedProject, setSelectedProject] = useState();
  const [projectModal, setProjectModal] = useState(false);
  const [shimmer, setShimmer] = useState(false);
  const [infiniteScroll, setInfiniteScroll] = useState(true);

  // --- Checklist state ---
  const [checklistRows, setChecklistRows] = useState<any[]>([]);
  const [checklistModal, setChecklistModal] = useState(false);
  const [checklistForm, setChecklistForm] = useState({ activity: '', yes_or_no: 'Sim', remarks: '' });
  const [editChecklistIdx, setEditChecklistIdx] = useState<number | null>(null);
  // -----------------------

  const [assetModalToggle, setSetAssetModalToggle] = useState(false);
  // const [activeChId, setActiveChId] = useState('');
  const [assets, setAssets] = useState<any>([]);
  const [searchText, setSearchText] = useState('');
  const [selectedAsset, setSelectedAsset] = useState();

  const handleChange = (event: any) => {
    const formentry: any = [...data];
    const f_index = formentry.findIndex((v: any) => v.field === event.target.id);
    const change_form_object = formentry[f_index];
    change_form_object.value = event.target.value;
    formentry[f_index] = change_form_object;
    setData(formentry);
  };

  const handleSelectChange = (event: any) => {
    const formentry: any = [...data];

    const select = event.target.name.replaceAll('-', '_');
    const f_index = formentry.findIndex((v: any) => v.field === select);
    if (select === 'maintenance_type') {
      formentry[f_index] = { ...formentry[f_index], value: event.target.value };
      const periodIndex = formentry.findIndex((v: any) => v.field === 'period');
      if (periodIndex !== -1) {
        if (event.target.value === 'Routine') {
          formentry[periodIndex] = { ...formentry[periodIndex], hide: false, required: true };
        } else {
          formentry[periodIndex] = { ...formentry[periodIndex], hide: true, required: false, value: '' };
        }
      }
    } else {
      formentry[f_index] = { ...formentry[f_index], value: event.target.value };
    }

    if (formentry[f_index].name === 'checklist') {
      formentry[f_index].btnDisabled = false;
    }
    setData(formentry);
  };

  // /* Checklist handlers */
  // const handleChangeCheck = (event: any) => {
  //   const formentry: any = { ...checklist };
  //   formentry[event.target.id] = event.target.value;
  //   setChecklist(formentry);
  // };

  // const handleSelectChangeCheck = (event: any) => {
  //   const formentry: any = { ...checklist };

  //   const select = event.target.name.replaceAll('-', '_');
  //   formentry[select] = event.target.value;
  //   setChecklist(formentry);
  // };

  useIonViewWillEnter(async () => {
    const Data = [...data];
    setShimmer(true);
    try {
      /* Get Asset name */
      const aname = Data.findIndex((d) => d.field === 'asset');
      Data[aname].options = await getSetAssetNameWithNoMaintenance('', '', currentPage); // Filter maintenance done assets
      const assetsList = Data[aname].options;

      setAssets(assetsList);

      /* Get Project by User */
      const pname = Data.findIndex((d) => d.field === 'project');
      const projectList = await getSetProjectList(0)
      console.log('projectList', projectList)
      // : localStorage.getItem('projectList') || [];
      Data[pname].options = projectList;
      if (projectList.length < 10) {
        setInfiniteScroll(false);
      }
      setProjects(projectList);


    } catch (error: any) {
      console.log(error);
    } finally {
      setShimmer(false);
    }


    /* Get CHECKLIST DETAILS ARRAY  */
    // const clist1 = Data.findIndex((d) => d.field === 'checklist1');
    // Data[clist1].options = await getCheckList();

    // const clist2 = Data.findIndex((d) => d.field === 'checklist2');
    // Data[clist2].options = Data[clist1].options;

    // const clist3 = Data.findIndex((d) => d.field === 'checklist3');
    // Data[clist3].options = Data[clist1].options;

    setData(Data);
  });

  useEffect(() => {
    // (async () => {
    //   const internetStatus = await Network.getStatus();
    //   setIsOnline(internetStatus.connected);

    //   Network.addListener('networkStatusChange', (status) => {
    //     setIsOnline(status.connected);
    //   });
    // })();
  }, []);


  async function searchNextProject($event: CustomEvent<void>) {
    try {
      const res = await getSetProjectList(currentPage + 1);
      if (res?.length) {

        setProjects([...projects, ...res]);
      }
    } catch (error: any) {
      console.log(error)
    } finally {
      setShimmer(false)
      setCurrentPage(currentPage + 1);
    }
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  const Submit = (e: any) => {
    e.preventDefault();
    // const url = '/resource/Maintenance Request';
    for (const x in data) {
      if (data[x].required && !data[x].value) {
        present({
          message: t(`Utils.fieldMissing`),
          color: 'danger',
          duration: 2000,
        });
        return
      }
    }

    hitCreateApi();

    // if (valid) {
    //   uploadFiles();
    //   if (!isOnline) {
    //     const allData = JSON.parse(localStorage.getItem('allData') || '[]');
    //     const newData = { data, url };
    //     allData.push(newData);
    //     localStorage.setItem('allData', JSON.stringify(allData));
    //   }
    // }
  };

  // const uploadFiles = async () => {
  //   setShowLoading(true);
  //   for (const item in data) {
  //     if (data[item].type === 'file') {
  //       try {
  //         
  //         if (data[item].src?.length > 0) {
  //           const f_index = data.findIndex((v: any) => v.field === 'name1');
  //           
  //           const response = await fetch(data[item].src?.toString());
  //           const blob = await response.blob();
  //           const formData = new FormData();
  //           formData.append(
  //             'file',
  //             new File([blob], `${data[f_index].value}-${data[item].field}.${data[item].format}`, {
  //               type: `image/${data[item].format}`,
  //             })
  //           );

  //           formData.append('is_private', '0');
  //           formData.append('folder', 'Home');
  //           formData.append('doctype', 'Maintenance Request');
  //           var config: any = {
  //             method: 'post',
  //             url: '/method/upload_file',
  //             headers: {
  //               'Content-Type': 'application/json',
  //               Accept: 'application/json',
  //               Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
  //             },
  //             data: formData,
  //           };
  //           const res = await axios(config);
  //           data[item].value = res?.data?.message?.file_url;
  //           setData(data);
  //         }
  //       } catch (e: any) {
  //         data[item].value = '';
  //       }
  //     }
  //   }
  //   hitCreateApi();
  // };

  const hitCreateApi = async () => {
    const formData = new FormData();
    for (const item in data) {
      if (data[item].type === 'file') {
        try {

          if (data[item].src?.length > 0) {
            // const f_index = data.findIndex((v: any) => v.field === 'name1');

            const response = await fetch(data[item].src?.toString());
            const blob = await response.blob();
            formData.append(

              data[item]?.field,
              new File([blob], `${new Date()?.getTime()}-${data[item].field}.${data[item].format}`, {
                type: `image/${data[item].format}`,
              })
            );
          }
        } catch (e: any) {
          data[item].value = '';
        }
      } else {
        const field = data[item]?.field;
        const value = data[item]?.value;
        if (typeof field === 'string' && typeof value === 'string') {
          formData.append(field, value);
        }
      }
    }
    if (checklistRows.length > 0) {
      formData.append('maintenance_checklist_details1', JSON.stringify(checklistRows));
    }


    const config: any = {
      method: 'post',
      url: 'method/preflet_asset.api.create_maintenance_request',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: formData
    };

    setShowLoading(true);
    axios(config)
      .then(async (res) => {
        if (res.status === 200) {
          present({
            message: t('Maintenance.CreateM.successMRC'),
            duration: 2000,
          });
          reset();
          router.goBack();
        }
      })
      .catch(function (error) {
        console.log(error?.response?.data?.message);
        present({
          message: error?.response?.data?.message || "Something went wrong",
          color: 'danger',
          duration: 2000,
        });
      })
      .finally(() => {
        setShowLoading(false);
      });
  };

  const reset = () => {
    const formentry: any = [...data];
    let x: any;
    for (x in formentry) {
      if (formentry[x].type === 'select') {
        formentry[x] = { ...formentry[x], value: '' };
      } else if (formentry[x].type === 'file') {
        formentry[x] = { ...formentry[x], value: '', src: '', format: '' };
      } else {
        formentry[x] = { ...formentry[x], value: '' };
      }

      if (formentry[x].field === 'period') {
        formentry[x] = { ...formentry[x], hide: true, required: false };
      }
    }
    setData(formentry);
    setChecklistRows([]);
  };

  // const [showModal, setShowModal] = useState(false);

  // const edit = (temp: any) => {
  //   setActiveChId(temp);

  //   for (const x in data) {
  //     if (data[x].field === temp) {
  //       if (!data[x].value) {
  //         present({
  //           message: data[x].requiredText,
  //           color: 'danger',
  //           duration: 2000,
  //         });
  //       } else {
  //         setShowModal(true);
  //       }
  //     }
  //     // else if (data[x].name === temp) {
  //     //   
  //     //   setChArray(data[x].value);
  //     // }
  //   }
  // };

  /* Add button to add CHECKLIST in ARRAY */

  // const saveCheckList = (flag: any) => {
  //   if (checklist.activity && checklist.yes_or_no) {
  //     var tempList = [...chArray];
  //     
  //     tempList.push(checklist);
  //     setChArray(tempList);
  //     setChecklist({
  //       activity: '',
  //       yes_or_no: '',
  //       remarks: '',
  //     });
  //   } else {
  //     present({
  //       message: t('Utils.required'),
  //       color: 'danger',
  //       duration: 2000,
  //     });
  //   }
  // };

  /* Scan returns Asset Id to Map asset name */

  // const sendIdBackToPage = (id: any) => {
  //   try {
  //     mapAssetId(id);
  //   } catch (error: any) {
  //     console.log('failed while fetching data');
  //   }
  // };

  // const mapAssetId = (assetId: any) => {
  //   // eslint-disable-next-line array-callback-return
  //   createMaintenanceFields.map((element) => {
  //     if (element.field === 'asset') {
  //       element.value = assetId;
  //     }
  //   });
  //   setData(createMaintenanceFields);
  // };

  const takePicture = async (imageElementIndex: number) => {
    try {
      const image = await Camera.getPhoto({
        quality: 70,
        allowEditing: true,
        resultType: CameraResultType.Uri,
      });

      // image.webPath will contain a path that can be set as an image src.
      // You can access the original file using image.path, which can be
      // passed to the Filesystem API to read the raw data of the image,
      // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
      const imageUrl = image.webPath;

      // Can be set to the src of an image now
      const formentry: any = [...data];
      formentry[imageElementIndex].src = imageUrl;
      formentry[imageElementIndex].format = image.format;
      setData(formentry);
    } catch (e: any) {/*empty*/ }
  };

  // const deleteFunc = (item: any, index: any) => {
  //   var tempList = [...chArray];
  //   tempList = tempList.filter((item, i) => i !== index);
  //   setChArray(tempList);
  //   if (!tempList.length) {
  //     var tempData = [...data];
  //     // for (const item in tempData) {
  //     //   if (tempData[item].name === activeChId) {
  //     //     tempData[item].value = tempList;
  //     //   }
  //     // }
  //     setData(tempData);
  //     setChArray([]);
  //   }
  // };

  /* Save CHECKLIST  */
  // const saveCheckListData = () => {
  //   var tempData = [...data];
  //   for (const item in tempData) {
  //     if (tempData[item].name === activeChId) {
  //       tempData[item].value = chArray;
  //     }
  //   }
  //   setData(tempData);
  //   setChArray([]);
  //   setShowModal(false);
  // };

  async function searchNext($event: CustomEvent<void>) {
    const res = await getSetAssetNameWithNoMaintenance('', searchText, currentPage + 1);
    if (res.length) {

      setAssets([...assets, ...res]);
    }
    setCurrentPage(currentPage + 1);
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  const setAssetInValue = (asset: any) => {
    const Data = [...data];
    const aname = Data.findIndex((d) => d.field === 'asset');
    Data[aname].value = asset;
    setData(Data);
    setSelectedAsset(asset);
  }

  const handleSearch = async (text: any) => {
    setSearchText(text);
    const res = await getSetAssetNameWithNoMaintenance('', text, 1);
    if (res.length) {
      setAssets(res);
    } else {
      setAssets([])
    }
    setCurrentPage(1);
  }

  const Shimmer = () => {
    return (
      <div>
        {
          [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((element) => {
            return (
              <div
                key={element}
                id="shimmer-body"
                style={{ padding: '1rem' }}
                className="w-50 data-list shimmer-container"
              >
                <div className="flex justify-between">
                  <IonSkeletonText animated style={{ width: '50%' }} />
                  <IonSkeletonText animated style={{ width: '20%' }} />
                </div>
              </div>
            );
          })
        }
      </div>
    );
  };

  const setProjectInValue = async (project: any) => {
    setSelectedProject(project);

    // First set the project field value immediately so the UI updates
    setData((prev: any) => {
      const updated = prev.map((f: any) => ({ ...f }));
      const pIdx = updated.findIndex((f: any) => f.field === 'project');
      if (pIdx !== -1) updated[pIdx].value = project;
      return updated;
    });

    if (!project) {
      // Clear project_id and project_location if project is unset
      setData((prev: any) => {
        const updated = prev.map((f: any) => ({ ...f }));
        const idIdx = updated.findIndex((f: any) => f.field === 'project_id');
        const locIdx = updated.findIndex((f: any) => f.field === 'project_location');
        if (idIdx !== -1) { updated[idIdx].value = ''; updated[idIdx].disabled = false; }
        if (locIdx !== -1) { updated[locIdx].value = ''; updated[locIdx].disabled = false; }
        return updated;
      });
      return;
    }

    setShowLoading(true);
    try {
      const fields = encodeURIComponent(JSON.stringify(['project_id', 'location']));
      const res = await axios({
        method: 'get',
        url: `/resource/Project/${encodeURIComponent(project)}?fields=${fields}`,
        headers: { Authorization: `Basic ${localStorage.getItem('hyprism_login')}` },
      });
      const projData = res?.data?.data;
      if (projData) {
        setData((prev: any) => {
          const updated = prev.map((f: any) => ({ ...f }));
          const idIdx = updated.findIndex((f: any) => f.field === 'project_id');
          const locIdx = updated.findIndex((f: any) => f.field === 'project_location');
          if (idIdx !== -1) {
            updated[idIdx].value = projData.project_id || '';
            updated[idIdx].disabled = true;
          }
          if (locIdx !== -1) {
            updated[locIdx].value = projData.location || '';
            updated[locIdx].disabled = true;
          }
          return updated;
        });
      }
    } catch (e: any) {
      console.log('Error fetching project details:', e?.response?.data || e);
      present({ message: 'Could not fetch project details', color: 'warning', duration: 2000 });
    } finally {
      setShowLoading(false);
    }
  }

  return (
    <IonPage>
      <Header enableBackButton={'/maintenanceHome'} title={t('Maintenance.Create')} />
      <IonContent>
        <IonLoading

          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={t('Utils.pleasewait')}
          duration={5000}
        />

        {/* <div style={{ display: 'flex', margin: 'auto', paddingTop: '2rem' }}>
          <button onClick={() => setIsScan(true)} className="scan-button">
            <img src={ScanAsset} alt="scan" style={{ paddingTop: '1rem' }} />
            <p className="scan-text">{t('Assets.Scan')}</p>
          </button>
        </div> */}

        {/* <p className="fill-text">{t('Assets.CreateA.Fill')}</p> */}

        <form
          className="ion-margin-top"
          style={{ textAlign: 'center', padding: '0 0.5rem', boxSizing: 'border-box', maxWidth: '600px', margin: '0 auto', width: '100%' }}
          onSubmit={(e) => Submit(e)}
        >
          <div className="responsive-form">
            {data.map((form_field: any, index: any) => {
              if (form_field.title) {
                return (
                  <p className="heading ion-margin form-title" key={`${form_field.title}-${index}`}>
                    {t(form_field.title)}
                  </p>
                );
              } else if (form_field.type === 'text') {
                return (
                  <div className="input-container" key={`${form_field.field}-${index}`}>
                    <label className="label">
                      {t(form_field.label)}
                      {form_field.required ? '*' : ''}
                    </label>
                    <input
                      required={form_field.required}
                      className="basic-input"
                      placeholder={t(form_field.label)}
                      id={form_field.field}
                      style={{ marginTop: '0.5rem', background: form_field.disabled ? '#F1F7F5' : '' }}
                      onChange={handleChange}
                      value={form_field.value}
                      disabled={form_field.disabled}
                    />
                  </div>
                );
              } else if (form_field.type === 'number') {
                return (
                  <div className="input-container" key={`${form_field.field}-${index}`}>
                    <label className="label">
                      {t(form_field.label)}
                      {form_field.required ? '*' : ''}
                    </label>
                    <input
                      type="number"
                      step="any"
                      required={form_field.required}
                      className="basic-input"
                      placeholder={t(form_field.label)}
                      id={form_field.field}
                      style={{ marginTop: '0.5rem', background: form_field.disabled ? '#F1F7F5' : '' }}
                      onChange={handleChange}
                      value={form_field.value}
                      disabled={form_field.disabled}
                    />
                  </div>
                );
              } else if (form_field.type === 'textarea') {
                return (
                  <div className="input-container" key={`${form_field.field}-${index}`} style={{ width: '100%', gridColumn: '1 / -1' }}>
                    <label className="label">
                      {t(form_field.label)}
                      {form_field.required ? '*' : ''}
                    </label>
                    <textarea
                      required={form_field.required}
                      className="textarea"
                      placeholder={t(form_field.label)}
                      id={form_field.field}
                      style={{ marginTop: '0.5rem', width: '100%', background: form_field.disabled ? '#F1F7F5' : '' }}
                      onChange={handleChange}
                      value={form_field.value}
                      disabled={form_field.disabled}
                    />
                  </div>
                );
              }
              // else if (form_field.name === 'checklist') {
              //   return (
              //     <div key={`${form_field.field}-${index}`}>
              //       <div className="" style={{ padding: '10px' }}>
              //         <div className="input-container">
              //           <label className="label">{t(form_field.label)}</label>
              //           <Select
              //             className="custom-select"
              //             required={form_field.required}
              //             id={`${form_field.field}_choice`}
              //             name={form_field.field}
              //             onChange={handleSelectChange}
              //             value={form_field.value}
              //             disabled={form_field.disabled || false}
              //             key={`${form_field.field}-${index}`}
              //           >
              //             {form_field.options &&
              //               form_field.options.map(function (opt: any, indexSelect: any) {
              //                 return (
              //                   <MenuItem
              //                     value={`${opt}`}
              //                     key={`${form_field.field}-${indexSelect}`}
              //                     id={`${opt}_item_${indexSelect}`}
              //                   >
              //                     <section style={{ display: 'flex', height: '1rem' }}>
              //                       <p
              //                         style={{
              //                           color: 'rgba(31, 87, 148, 1)',
              //                           marginLeft: '0.2rem',
              //                           fontSize: '12px',
              //                           marginTop: '0px',
              //                         }}
              //                       >
              //                         {t(opt)}
              //                       </p>
              //                     </section>
              //                   </MenuItem>
              //                 );
              //               })}
              //           </Select>
              //         </div>
              //         <div>
              //           <div
              //             style={{ color: 'rgba(31, 87, 148, 1)', marginBottom: '1rem' }}
              //             className="flex justify-between input-container"
              //           >
              //             {data.map((e: any, item: any) => {
              //               if (e.name === form_field.field && e.value.length) {
              //                 return (
              //                   <div className="flex items-center">
              //                     <IonIcon
              //                       style={{ fontSize: '25px', marginLeft: '1rem', marginRight: '0.5rem' }}
              //                       src={listCircle}
              //                     />
              //                     <span>{e.value.length}</span>
              //                   </div>
              //                 );
              //               }
              //             })}
              //             <div className="flex justify-center items-center">
              //               <span
              //                 className="pointer"
              //                 onClick={() => {
              //                   edit(form_field.field);
              //                 }}
              //               >
              //                 <u>{t(form_field.label)}</u>
              //               </span>
              //               <IonIcon
              //                 className="pointer"
              //                 style={{ fontSize: '25px', marginLeft: '10px' }}
              //                 onClick={() => {
              //                   edit(form_field.field);
              //                 }}
              //                 src={addCircle}
              //               />
              //             </div>
              //           </div>
              //           {/* CheckList Detail Modal */}
              //           <IonModal isOpen={showModal}>
              //             <IonHeader>
              //               <IonToolbar color="primary">
              //                 <IonTitle>{t(`Assets.CreateA.edit`)} </IonTitle>
              //                 <IonButtons slot="end">
              //                   <IonButton
              //                     onClick={() => {
              //                       setShowModal(false);
              //                     }}
              //                   >
              //                     <IonIcon name="close" slot="icon-only"></IonIcon>
              //                   </IonButton>
              //                 </IonButtons>
              //               </IonToolbar>
              //             </IonHeader>
              //             <IonContent>
              //               <div>
              //                 {chArray.length ? (
              //                   <div>
              //                     <table style={{ margin: 'auto', marginTop: '2rem' }}>
              //                       <tr>
              //                         <th style={{ textAlign: 'center', padding: '10px' }}>
              //                           {t(`Maintenance.CreateM.activity`)}
              //                         </th>
              //                         <th style={{ textAlign: 'center', padding: '10px' }}>
              //                           {t('Maintenance.CreateM.yes_o')}
              //                         </th>
              //                         <th style={{ textAlign: 'center', padding: '10px' }}>
              //                           {t('Maintenance.CreateM.remarks')}
              //                         </th>
              //                         <th style={{ textAlign: 'center', padding: '10px' }}>Delete</th>
              //                       </tr>
              //                       {chArray &&
              //                         chArray.map((item: any, indexList: any) => {
              //                           return (
              //                             <tr>
              //                               <td style={{ textAlign: 'center' }}>{item.activity}</td>
              //                               <td style={{ textAlign: 'center' }}>{item.yes_or_no}</td>
              //                               <td style={{ textAlign: 'center' }}>{item.remarks}</td>
              //                               <span>
              //                                 <IonIcon
              //                                   className="pointer"
              //                                   style={{
              //                                     color: 'red',
              //                                     margin: 'auto',
              //                                     display: 'block',
              //                                     marginTop: '5px',
              //                                     padding: '5px',
              //                                   }}
              //                                   src={trash}
              //                                   onClick={() => deleteFunc(item, indexList)}
              //                                 />
              //                               </span>
              //                             </tr>
              //                           );
              //                         })}
              //                     </table>
              //                     <button
              //                       // onClick={() => saveCheckListData()}
              //                       style={{
              //                         margin: 'auto',
              //                         display: 'block',
              //                         marginTop: '2rem',
              //                         paddingLeft: '30px',
              //                         paddingRight: '30px',
              //                         paddingTop: '15px',
              //                         paddingBottom: '15px',
              //                         color: 'white',
              //                         background: '#1d508d',
              //                         borderRadius: '5px',
              //                         fontWeight: 'bold',
              //                         fontSize: '10px',
              //                       }}
              //                     >
              //                       {t('Utils.save')}
              //                     </button>
              //                   </div>
              //                 ) : (
              //                   ''
              //                 )}

              //                 <div className="responsive-form">
              //                   {createCheckList &&
              //                     createCheckList.map((element: any, index1: any) => {
              //                       if (element.title) {
              //                         return (
              //                           <p className="heading ion-margin form-title" key={`${element.title}-${index1}`}>
              //                             {t(element.title)}
              //                           </p>
              //                         );
              //                       } else if (element.type === 'text') {
              //                         return (
              //                           <div className="input-container" key={`${element.field}-${index1}`}>
              //                             <label className="label">{t(element.label)}</label>
              //                             <input
              //                               required={element.required}
              //                               className="basic-input"
              //                               placeholder={t(element.label)}
              //                               id={element.field}
              //                               style={{ marginTop: '0.5rem' }}
              //                               onChange={handleChangeCheck}
              //                               
              //                               value={checklist[element.field]}
              //                             />
              //                           </div>
              //                         );
              //                       } else if (element.type === 'select') {
              //                         return (
              //                           <div className="input-container" key={`${element.field}-${index}`}>
              //                             <label className="label">
              //                               {t(element.label)}
              //                               {element.required ? '*' : null}
              //                             </label>
              //                             <Select
              //                               className="custom-select"
              //                               required={element.required}
              //                               id={`${element.field}_choice`}
              //                               name={element.field}
              //                               onChange={handleSelectChangeCheck}
              //                               
              //                               value={checklist[element.field]}
              //                             >
              //                               {element.options &&
              //                                 element.options.map(function (opt: any, indexSelect: any) {
              //                                   return (
              //                                     <MenuItem
              //                                       value={`${opt}`}
              //                                       key={`${element.field}-${indexSelect}`}
              //                                       id={`${opt}_item_${indexSelect}`}
              //                                     >
              //                                       <section style={{ display: 'flex', height: '1rem' }}>
              //                                         <p
              //                                           style={{
              //                                             color: 'rgba(31, 87, 148, 1)',
              //                                             marginLeft: '0.2rem',
              //                                             fontSize: '12px',
              //                                             marginTop: '0px',
              //                                           }}
              //                                         >
              //                                           {t(opt)}
              //                                         </p>
              //                                       </section>
              //                                     </MenuItem>
              //                                   );
              //                                 })}
              //                             </Select>
              //                           </div>
              //                         );
              //                       }
              //                     })}
              //                   <button
              //                     className="submit-button"
              //                     onClick={() => {
              //                       saveCheckList(form_field.field);
              //                     }}
              //                   >
              //                     {t('Utils.addButton')}
              //                   </button>
              //                 </div>
              //               </div>
              //             </IonContent>
              //           </IonModal>
              //         </div>
              //       </div>
              //     </div>
              //   );
              // } 
              else if (form_field.field === 'asset') {
                return (
                  <div className="input-container" key={`${form_field.field}-${index}`}>
                    <label className="label">
                      {t(form_field.label)}
                      {form_field.required ? '*' : null}
                    </label>
                    <p onClick={() => setSetAssetModalToggle(!assetModalToggle)} className='basic-input' style={{ marginTop: '0px', fontSize: '12px', color: '#a3a9b5' }}>{form_field.value || <span>{t('Utils.selectAsset')}</span>}</p>
                  </div>)
              }
              else if (form_field.field === 'project') {
                return (
                  <div className="input-container" key={`${form_field.field}-${index}`}>
                    <label className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}
                    </label>
                    <p onClick={() => setProjectModal(!projectModal)} className='basic-input' style={{ marginTop: '0px', fontSize: '12px', color: '#a3a9b5' }}>{form_field.value || <span>{t('Utils.selectProject')}</span>}</p>
                  </div>)
              }

              else if (form_field.type === 'select' && !form_field.hide) {
                return (
                  <div className="input-container" key={`${form_field.field}-${index}`}>
                    <label className="label">
                      {t(form_field.label)}
                      {form_field.required ? '*' : null}
                    </label>
                    {form_field.info ? (
                      <div className="tooltip">
                        <IonIcon style={{ marginBottom: '-4px' }} src={informationCircle} />
                        <span className="tooltiptext">{t(`Utils.${form_field.info}`)}</span>
                      </div>
                    ) : null}
                    <Select
                      className="custom-select"
                      required={form_field.required}
                      id={`${form_field.field}_choice`}
                      name={form_field.field}
                      onChange={handleSelectChange}
                      value={form_field.value}
                      disabled={form_field.disabled || false}
                    >
                      {form_field.options?.map(function (opt: any, indexSelect: any) {
                        return (
                          <MenuItem
                            value={`${opt}`}
                            key={`${form_field.field}-${indexSelect}`}
                            id={`${opt}_item_${indexSelect}`}
                          >
                            <section style={{ display: 'flex', height: '1rem' }}>
                              {/* <img src={Man} alt="Users" style={{ width: '15px' }} /> */}
                              <p
                                style={{
                                  color: 'rgba(31, 87, 148, 1)',
                                  marginLeft: '0.2rem',
                                  fontSize: '12px',
                                  marginTop: '0px',
                                }}
                              >
                                {t(opt)}
                              </p>
                            </section>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                );
              } else if (form_field.type === 'date' || form_field.type === 'datetime-local') {
                return (
                  <div className="input-container" key={`${form_field.field}-${index}`}>
                    <label className="label">
                      {t(form_field.label)}
                      {form_field.required ? '*' : null}
                    </label>
                    <input
                      required={form_field.required}
                      className="date"
                      id={form_field.field}
                      placeholder={t(form_field.label)}
                      onChange={handleChange}
                      value={form_field.value}
                      type={form_field.type}
                      disabled={form_field.disabled}
                      style={{ background: form_field.disabled ? '#F1F7F5' : '' }}
                    />
                  </div>
                );
              } else if (form_field.type === 'file') {
                return (
                  <div key={`${form_field.field}-${index}`} style={{ marginBottom: '12px', gridColumn: '1 / -1' }}>
                    <div
                      onClick={() => takePicture(index)}
                      style={{
                        border: form_field.src ? '2px solid #1F5794' : '2px dashed #b0c4de',
                        borderRadius: '14px',
                        padding: form_field.src ? '0' : '20px 12px',
                        cursor: 'pointer',
                        background: form_field.src ? 'transparent' : '#f4f8fe',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: form_field.src ? 'auto' : '90px',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      {form_field.src ? (
                        <>
                          <img
                            src={form_field.src}
                            alt=""
                            style={{ width: '100%', borderRadius: '12px', display: 'block', maxHeight: '180px', objectFit: 'cover' }}
                          />
                          <div style={{
                            position: 'absolute', bottom: 0, left: 0, right: 0,
                            background: 'rgba(0,0,0,0.45)', padding: '6px 12px',
                            display: 'flex', justifyContent: 'center',
                          }}>
                            <span style={{ color: 'white', fontSize: '12px', fontWeight: 600 }}>✎ {t('Utils.change_image')}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ fontSize: '28px', marginBottom: '6px', color: '#7aa7d8' }}>📷</div>
                          <p style={{ margin: 0, fontSize: '13px', color: '#7aa7d8', fontWeight: 600 }}>{t('Utils.image')}</p>
                          <p style={{ margin: '2px 0 0', fontSize: '10px', color: '#aac4e0' }}>Tap to upload</p>
                        </>
                      )}
                    </div>
                  </div>
                );
              } else {
                return '';
              }
            })}
          </div>

          {/* ── Checklist Section ── */}
          <div style={{ padding: '0 1rem', gridColumn: '1 / -1' }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              margin: '1rem 0 0.5rem',
            }}>
              <p style={{ fontWeight: 700, fontSize: '15px', color: '#1d508d', margin: 0 }}>
                Checklist
              </p>
              <button
                type="button"
                onClick={() => {
                  setChecklistForm({ activity: '', yes_or_no: 'Sim', remarks: '' });
                  setEditChecklistIdx(null);
                  setChecklistModal(true);
                }}
                style={{
                  background: '#1d508d', color: 'white', border: 'none',
                  borderRadius: '20px', padding: '6px 16px', fontSize: '12px',
                  fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px',
                }}
              >
                + Add Item
              </button>
            </div>

            {checklistRows.length === 0 && (
              <p style={{ textAlign: 'center', color: '#b0c4de', fontSize: '12px', margin: '1rem 0' }}>
                No checklist items added yet
              </p>
            )}

            {checklistRows.map((row: any, idx: number) => (
              <div key={idx} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                border: '1px solid #dbe6ec', borderRadius: '12px',
                padding: '10px 14px', marginBottom: '8px', background: '#f9fbff',
              }}>
                <div style={{ flex: 1 }}>
                  <p style={{ margin: 0, fontWeight: 700, fontSize: '13px', color: '#243656' }}>{row.activity}</p>
                  {row.remarks && <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#929bab' }}>{row.remarks}</p>}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{
                    padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700,
                    background: row.yes_or_no === 'Sim' ? '#e6f9f0' : '#fdecea',
                    color: row.yes_or_no === 'Sim' ? '#1aaa55' : '#e53935',
                  }}>{row.yes_or_no === 'Sim' ? 'Yes' : 'No'}</span>
                  <span
                    onClick={() => {
                      setChecklistForm({ activity: row.activity, yes_or_no: row.yes_or_no, remarks: row.remarks || '' });
                      setEditChecklistIdx(idx);
                      setChecklistModal(true);
                    }}
                    style={{ fontSize: '18px', cursor: 'pointer', color: '#1d508d' }}
                  >✎</span>
                  <span
                    onClick={() => setChecklistRows((prev: any[]) => prev.filter((_: any, i: number) => i !== idx))}
                    style={{ fontSize: '20px', cursor: 'pointer', color: '#e53935', fontWeight: 700, lineHeight: 1 }}
                  >×</span>
                </div>
              </div>
            ))}
          </div>
          {/* ── End Checklist ── */}

          <button className="submit-button" type="submit">
            {t(`Maintenance.CreateM.CR`)}{' '}
          </button>
          <div style={{ marginBottom: '3rem' }}></div>
        </form>

        {/* Checklist Row Entry Modal */}
        <IonModal isOpen={checklistModal} onDidDismiss={() => setChecklistModal(false)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>{editChecklistIdx !== null ? 'Edit Checklist Item' : 'Add Checklist Item'}</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setChecklistModal(false)}>Close</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent style={{ '--padding-top': '1rem', '--padding-start': '1rem', '--padding-end': '1rem' }}>
            <div style={{ padding: '1rem' }}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ fontWeight: 700, fontSize: '13px', color: '#243656', opacity: 0.7, display: 'block', marginBottom: '6px' }}>
                  Activity *
                </label>
                <input
                  className="basic-input"
                  placeholder="Describe the activity"
                  value={checklistForm.activity}
                  style={{ marginTop: 0 }}
                  onChange={(e) => setChecklistForm((f) => ({ ...f, activity: e.target.value }))}
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ fontWeight: 700, fontSize: '13px', color: '#243656', opacity: 0.7, display: 'block', marginBottom: '6px' }}>
                  Status
                </label>
                <Select
                  className="custom-select"
                  value={checklistForm.yes_or_no}
                  name="yes_or_no"
                  onChange={(e: any) => setChecklistForm((f) => ({ ...f, yes_or_no: e.target.value }))}
                >
                  <MenuItem value="Sim"><p style={{ color: '#1aaa55', fontWeight: 700, fontSize: '13px', margin: 0 }}>Yes</p></MenuItem>
                  <MenuItem value="Não"><p style={{ color: '#e53935', fontWeight: 700, fontSize: '13px', margin: 0 }}>No</p></MenuItem>
                </Select>
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontWeight: 700, fontSize: '13px', color: '#243656', opacity: 0.7, display: 'block', marginBottom: '6px' }}>
                  Remarks
                </label>
                <textarea
                  className="textarea"
                  placeholder="Optional remarks"
                  value={checklistForm.remarks}
                  style={{ marginTop: 0 }}
                  onChange={(e) => setChecklistForm((f) => ({ ...f, remarks: e.target.value }))}
                />
              </div>

              <button
                type="button"
                className="submit-button"
                style={{ marginTop: 0 }}
                onClick={() => {
                  if (!checklistForm.activity.trim()) {
                    present({ message: 'Activity is required', color: 'warning', duration: 1500 });
                    return;
                  }
                  const row = { activity: checklistForm.activity.trim(), yes_or_no: checklistForm.yes_or_no, remarks: checklistForm.remarks.trim() };
                  if (editChecklistIdx !== null) {
                    setChecklistRows((prev: any[]) => prev.map((r: any, i: number) => i === editChecklistIdx ? row : r));
                  } else {
                    setChecklistRows((prev: any[]) => [...prev, row]);
                  }
                  setChecklistModal(false);
                }}
              >
                {editChecklistIdx !== null ? 'Save Changes' : 'Add Item'}
              </button>
            </div>
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={assetModalToggle}
          onDidDismiss={() => setSetAssetModalToggle(false)}
        ><IonHeader>
            <IonToolbar>
              <IonTitle>Assets</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setSetAssetModalToggle(false)}>Close</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonSearchbar
              className="data-list"
              value={searchText}

              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              onIonChange={(e) => handleSearch(e.detail.value!)}
            ></IonSearchbar>
            {shimmer && <Shimmer />}
            <IonList>
              {assets?.length ? assets.map((asset: any, index: any) => (
                <IonItem
                  key={index}
                  onClick={() => {
                    setSetAssetModalToggle(false);
                    setAssetInValue(asset)
                  }}
                >
                  <IonLabel>{asset}</IonLabel>
                  <IonCheckbox
                    slot="end"
                    value={asset}
                    checked={asset === selectedAsset} />
                </IonItem>
              )) :
                <div style={{ margin: 'auto', display: 'block' }}>
                  <p className='text-center' style={{ color: 'gray' }}>No Asset found</p>
                </div>}
            </IonList>

            <IonInfiniteScroll onIonInfinite={(e: CustomEvent<void>) => searchNext(e)}>
              <IonInfiniteScrollContent
                loadingSpinner="bubbles"
                loadingText="Loading more data..."
              ></IonInfiniteScrollContent>
            </IonInfiniteScroll>
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={projectModal}
          onDidDismiss={() => setProjectModal(false)}
        ><IonHeader>
            <IonToolbar>
              <IonTitle>Projects</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setProjectModal(false)}>Close</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            {shimmer && <Shimmer />}
            <IonList>
              {projects.length ? projects.map((project: any, index: number) => (
                <IonItem
                  key={index}
                  onClick={() => {
                    setProjectModal(false);
                    setProjectInValue(project)
                  }}
                >
                  <IonLabel>{project}</IonLabel>
                  <IonCheckbox
                    slot="end"
                    value={project}
                    checked={project === selectedProject} />
                </IonItem>
              )) :
                <div style={{ margin: 'auto', display: 'block' }}>
                  <p className='text-center' style={{ color: 'gray' }}>No Asset found</p>
                </div>}
            </IonList>
            {infiniteScroll ?
              <IonInfiniteScroll onIonInfinite={(e: CustomEvent<void>) => searchNextProject(e)}>
                <IonInfiniteScrollContent
                  loadingSpinner="bubbles"
                  loadingText="Loading more data..."
                ></IonInfiniteScrollContent>
              </IonInfiniteScroll> : ''}
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default CreateMainten1;
